// extracted by mini-css-extract-plugin
export default {"avatar":"Avatar_avatar__le9M8","indicator":"Avatar_indicator__norD6","active":"Avatar_active__ifUdO"};